// ===================================================
// HEADER SCROLLED
// ===================================================

function headerScrolled() {
  //var headerHeight = $('header').offset().top;
  if (window.scrollY > 80) {
    $('.responsive--logo').addClass('scrolled');
  }

  if (window.scrollY < 10) {
    $('.responsive--logo').removeClass('scrolled');
  }
}
headerScrolled();

window.addEventListener("scroll", () => {
  headerScrolled();
});


// ===================================================
// OPEN WHOLESALE POPUPS
// ===================================================

function closeInfoPopups() {
  var allPopUpButtons = $('.open--info--popup');
  var allPopUpWindows = $('.info--popup');
  $(allPopUpButtons).removeClass('active');
  $(allPopUpWindows).removeClass('active');
  $('#MainContent').removeClass('thank-you');
  
  $(allPopUpWindows).find('iframe').attr('src', null);
}

$('.open--info--popup').click(function(){
  closeInfoPopups();
  
  var targetPopupWindow = '#' + $(this).data('popup');
  $(this).addClass('active');
  $(targetPopupWindow).addClass('active');

  var iframe    = $(targetPopupWindow).find('iframe');
  var iframeSrc = $(iframe).attr('data-src');

  $(iframe).attr('src', iframeSrc);

});

$('.close--info--popups').click(function(){
  closeInfoPopups();
});

$(document).on('keydown', function(event) {
  if (event.key == "Escape") {
    closeInfoPopups();
  }
});


// ===================================================
// INSTAGRAM TICKER
// ===================================================

function instagramTicker() {

  // utility functions
  if(!Util) function Util () {};

  Util.addClass = function(el, className) {
    var classList = className.split(' ');
    el.classList.add(classList[0]);
    if (classList.length > 1) Util.addClass(el, classList.slice(1).join(' '));
  };

  Util.removeClass = function(el, className) {
    var classList = className.split(' ');
    el.classList.remove(classList[0]);
    if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(' '));
  };

  Util.osHasReducedMotion = function() {
    if(!window.matchMedia) return false;
    var matchMediaObj = window.matchMedia('(prefers-reduced-motion: reduce)');
    if(matchMediaObj) return matchMediaObj.matches;
    return false; 
  };

  // File#: _1_ticker
  // Usage: codyhouse.co/license
  (function() {
    var Ticker = function(element) {
      this.element = element;
      this.list = this.element.getElementsByTagName('ul')[0];
      this.items = this.list.children;
      this.paused = false;
      // clones info
      this.clones = this.list.innerHTML;
      this.clonesNumber = 1;
      this.itemsLength = this.items.length;
      // animation duration
      this.animationDuration = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ticker-animation-duration'));
      initTicker(this);
    };

    function initTicker(ticker) {
      // clone ticker children
      setTickerWidth(ticker);
      cloneItems(ticker);
      initAnimation(ticker);

      // resize/font loaded event
      ticker.element.addEventListener('update-ticker', function(event){
        setTickerWidth(ticker);
        cloneItems(ticker);
      });

      // click on control button events
      ticker.element.addEventListener('anim-ticker', function(event){
        ticker.paused = false;
        Util.removeClass(ticker.element, 'ticker--paused');
      });

      ticker.element.addEventListener('pause-ticker', function(event){
        ticker.paused = true;
        Util.addClass(ticker.element, 'ticker--paused');
      });

      // all set
      Util.addClass(ticker.element, 'ticker--loaded');
    };

    function setTickerWidth(ticker) {
      var width = 0;
      for(var i = 0; i < ticker.itemsLength; i++) {
        width = width + getItemWidth(ticker.items[i]);
      }
      // check if we need to update the number of clones
      if(width < window.innerWidth) {
        ticker.clonesNumber = Math.ceil(window.innerWidth/width) * 2 - 1;
      } else {
        ticker.clonesNumber = 1;
      }

      // update list width
      ticker.list.style.width = ((ticker.clonesNumber + 1)*width)+'px';
    };

    function getItemWidth(item) {
      var style = window.getComputedStyle(item);
      return parseFloat(style.marginRight) + parseFloat(style.marginLeft) + item.offsetWidth;
    };

    function cloneItems(ticker) {
      ticker.list.innerHTML = ticker.clones;
      for(var i = 0; i < ticker.clonesNumber; i++) {
        ticker.list.insertAdjacentHTML('beforeend', ticker.clones);
      }
      // update animation duration
      ticker.element.style.setProperty('--ticker-animation-duration', ticker.animationDuration*(ticker.clonesNumber+1)+'s');
    };

    function initAnimation(ticker) {
      // init observer - animate ticker only when in viewport
      var observer = new IntersectionObserver(tickerObserve.bind(ticker));
      observer.observe(ticker.element);
      
    };

    function tickerObserve(entries) {
      if(entries[0].isIntersecting) {
        if(!this.paused) Util.addClass(this.element, 'ticker--animate');
      } else {
        Util.removeClass(this.element, 'ticker--animate');
      }
    };

    function initTickerController(controller) {
      // play/pause btn controller
      var tickerContainer = document.getElementById(controller.getAttribute('aria-controls'));
      if(!tickerContainer) return;
      var tickerList = tickerContainer.getElementsByClassName('js-ticker');
      if(tickerList.length < 1) tickerList = [tickerContainer];
      // detect click
      controller.addEventListener('click', function(event){
        var playAnimation = controller.getAttribute('aria-pressed') == 'true';
        var animEvent = playAnimation ? 'anim-ticker' : 'pause-ticker';
        playAnimation ? controller.setAttribute('aria-pressed', 'false') : controller.setAttribute('aria-pressed', 'true');
        for(var i = 0; i < tickerList.length; i++) {
          tickerList[i].dispatchEvent(new CustomEvent(animEvent));
        }
      });
    };

    //initialize the Ticker objects
    var tickers = document.getElementsByClassName('js-ticker'),
      requestAnimationFrameSupported = window.requestAnimationFrame,
      reducedMotion = Util.osHasReducedMotion(),
      intersectionObserverSupported = ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype);

    if( tickers.length > 0 ) {
      var tickersArray = [];
      for( var i = 0; i < tickers.length; i++) {
        if(!requestAnimationFrameSupported || reducedMotion || !intersectionObserverSupported) {
          // animation is off if requestAnimationFrame/IntersectionObserver is not supported or reduced motion is on
          Util.addClass(tickers[i], 'ticker--anim-off');
        } else {(function(i){tickersArray.push(new Ticker(tickers[i]));})(i);}
      }

      if(tickersArray.length > 0) {
        var resizingId = false,
          customEvent = new CustomEvent('update-ticker');
        
        // on resize -> update ticker width 
        window.addEventListener('resize', function() {
          clearTimeout(resizingId);
          resizingId = setTimeout(doneResizing, 500);
        });

        // wait for font to be loaded -> update ticker width
        if(document.fonts) {
          document.fonts.onloadingdone = function (fontFaceSetEvent) {
            doneResizing();
          };
        }

        function doneResizing() {
          for( var i = 0; i < tickersArray.length; i++) {
            (function(i){tickersArray[i].element.dispatchEvent(customEvent)})(i);
          };
        };

        // ticker play/pause buttons
        var tickerControl = document.getElementsByClassName('js-ticker-control');
        if(tickerControl.length > 0) {
          for( var i = 0; i < tickerControl.length; i++) {
            if(!requestAnimationFrameSupported || reducedMotion || !intersectionObserverSupported) {
              Util.addClass(tickerControl[i], 'tt9-hide');
            } else {
              (function(i){initTickerController(tickerControl[i]);})(i);
            } 
          }
        }
      };
    }
  }());

}
$(document).ready(function () {
  instagramTicker();
});

// ===================================================
// FADE IN WHEN IN VIEW
// ===================================================

function checkElementLocation() {
  var $window = $(window);
  var bottom_of_window = $window.scrollTop() + $window.height();

  $('.animate').each(function() {
    var $that = $(this);
    var bottom_of_object = $that.position().top + ($that.outerHeight() / 2);

    //if element is in viewport, add the animate class
    if (bottom_of_window > bottom_of_object) {
      $(this).find('.anim').each(function(index) {
        var timing = index * 100;
        $(this).delay(timing).queue(function(){$(this).addClass('inview')});
      });
    }

  });

}
// if in viewport, show the animation
$(document).ready(function () {
  checkElementLocation();
});
$(window).on('scroll', function() {
  checkElementLocation();
});
$(window).resize(function () {
  checkElementLocation();
});


// ===================================================
// COMPETITION POPUP
// ===================================================

$(document).ready(function(){
  $('#competition-popup-trigger').click(function(){
    $('#competition-popup').removeClass('translate-y-full');
  });
  $('.close-competition-popup').click(function(){
    $('#competition-popup').addClass('translate-y-full');
  });
});

// ===================================================
// TRANSPARENT NAV
// ===================================================

function isScrolledIntoView(elem) {
    var rect = elem.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;


    // Only completely visible elements return true:
    //var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);

    // Partially visible elements return true:
    //isVisible = elemTop < window.innerHeight && elemBottom >= 0;

    // After scrolling 1/3 of window height
    isVisible = elemTop < window.innerHeight && elemBottom >= (window.innerHeight / 3);

    return isVisible;
}

function overCover() {
  if($('#section-hero-banner').length) {
    $('#section-hero-banner').each(function () {
        if (isScrolledIntoView(this) === true) {
          $('body').removeClass('scrolled');
        } else {
          $('body').addClass('scrolled');
        }
    });
  }
}
$(window).scroll(function () {
  overCover();
});

// ===================================================
// PLAY MACHINE
// ===================================================

$('#start-machine').click(function(){
  $('#machine-container').addClass('active');
  $('#json_machine').get(0).play();
  $(this).addClass('active');

  function removeActive() {
    $('#machine-container').removeClass('active');
    $('#start-machine').removeClass('active');
    $('#json_machine').get(0).stop();
  }
  setTimeout(removeActive, 17000);
});

if ($('#mission-milliways').length) {
  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  }
}

// ===================================================
// FAQ BUTTON YELLOW
// ===================================================

$(document).ready(function(){
  $('.faq-child-button').click(function(){
    var attr = $(this).attr('aria-expanded');
    if (attr === 'true') {
      $('.faq-button').removeClass('yellow');
      $(this).parent('.faq-button').removeClass('yellow');
    }
    if (attr === 'false') {
      $('.faq-button').removeClass('yellow');
      $(this).parent('.faq-button').addClass('yellow');
    }
  });
});

// ===================================================
// BACKGROUND COLOUR CHANGE
// ===================================================

jQuery(function($){

  function changer() {
    
      // selectors
      var $window = $(window),
      $body = $('#MainContent'),
      $panel = $('.changer');

      // Change 33% earlier than scroll position so colour is there when you arrive.
      var scroll = $window.scrollTop() + ($window.height() / 2);

      $panel.each(function () {
      var $this = $(this);

      // if position is within range of this panel.
      // So position of (position of top of div <= scroll position) && (position of bottom of div > scroll position).
      // Remember we set the scroll to 33% earlier in scroll var.
      if ($this.position().top <= scroll && $this.position().top + $this.height() > scroll) {

        // Remove all classes on body with color-
        $body.removeClass(function (index, css) {
          return (css.match (/(^|\s)color-\S+/g) || []).join(' ');
        });

        // Add class of currently active div
        $body.addClass('color-' + $(this).data('background'));
      }
    });
  }

  $(document).ready(function() {
    changer();
  }).scroll();
  $(window).scroll(function() {
    changer();
  }).scroll();

  // ================MILLIWAYS MISSION===================

  $('#start-mission').click(function() {
    $('.hidden-by-rocket').removeClass('hidden-by-rocket');
    $('#rocket_container').addClass('active');
    changer();
  });

});
  

// $(window).load(function() {
//   $('#MainContent').addClass('ready');
// });

// ===================================================
// PRODUCT TABS
// ===================================================

'use strict';

function Tabs() {

  var bindAll = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].addEventListener('click', change, false);
    }
  }

  var clear = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].classList.remove('active');
      var id = menuElements[i].getAttribute('data-tab');
      document.getElementById(id).classList.remove('active');
    }
  }

  var change = function(e) {
    clear();
    e.target.classList.add('active');
    var id = e.currentTarget.getAttribute('data-tab');
    document.getElementById(id).classList.add('active');
  }

  bindAll();
}

var connectTabs = new Tabs();

$(document).ready(() => {
  var $carousel = $('.reviews-slider').flickity();
  $('button[data-tab="reviews"]').on( 'click', function() {
    // expand gallery by toggling class
    $carousel.toggleClass('is-expanded')
      .flickity('resize');
  });
});

$(document).ready(function(){
    if($('.sidebar-slider') > 0) {
      $(window).load(function() {
      var contentElems = document.querySelectorAll('.sidebar-slider');
        for ( var i=0, len = contentElems.length; i < len; i++ ) {
        var contentElem = contentElems[i];
        new Flickity( contentElem, {
            wrapAround: false,
            prevNextButtons: false,
            pauseAutoPlayOnHover: false,
            autoPlay: false,
            pageDots: false,
            imagesLoaded: true,
            cellAlign: 'left',
            contain: true,
            //fade: true,
            draggable: true,
            imagesLoaded: false
        });
      }

    });
  }
});

$(document).ready(() => {
  var contentElems = document.querySelectorAll('.homepage--pack--slider');
        for ( var i=0, len = contentElems.length; i < len; i++ ) {
        var contentElem = contentElems[i];
        new Flickity( contentElem, {
            wrapAround: true,
            prevNextButtons: false,
            pauseAutoPlayOnHover: false,
            autoPlay: 3000,
            pageDots: false,
            imagesLoaded: true,
            cellAlign: 'left',
            contain: true,
            draggable: true,
            imagesLoaded: false
        });
      }
});